export default __webpack_public_path__ + "static/media/Copperplate-Bold.69a8f379.ttf";